<div
  class="doc-view-container"
  [class]="isNewTab ? 'doc-view-container-new-tab' : ''"
>
  @if (fileData) {
  <div>
    <app-summarize-chat [data]="fileData" />
  </div>
  }
  <div [class]="_action.isShowExtractedEntity ? 'doc-view-body-container mt-2 flex':'doc-view-body-container mt-2 flex doc-view-body-container-entity'"  #docViewBody>
    <p-splitter>
      <ng-template pTemplate>
        <div class="doc-view-body secondary-shadow flex-1">
          <div class="doc-view-header">
            <div class="title-container">
              <div class="title">{{ docTitle }}</div>
              <div class="subtitle">{{ docType }}</div>
            </div>
            <div>
              <app-toolbar
                [toolbar]="toolbar"
                (openEmailInfoEvent)="openDocInfo($event)"
              ></app-toolbar>
            </div>
          </div>
          <div>
            <app-doc-viewer
              [data]="data"
              [filePath]="data._source.filePath"
            ></app-doc-viewer>
          </div>
          @if (fileData) {
          <div class="m-2" id="comment-section">
            <app-comments [data]="data" />
          </div>
          }
        </div>
      </ng-template>
      <ng-template pTemplate>
        @if (_action.isShowExtractedEntity) {
        <div
          class="secondary-shadow extracted-entity-viewer"
          style="height: inherit"
        >
          <app-extraction-detail
            [extraction]="_extraction.selectedExtractionForSearch"
            [maxHeight]="docViewBodyHeight"
            [close]="closeExtractionDetails"
          ></app-extraction-detail>
        </div>
        }
      </ng-template>
    </p-splitter>
  </div>
</div>

<p-confirmPopup #confirmPopupRef key="docInfoPopup" appendTo="body">
  <ng-template pTemplate="headless">
    <div>
      <app-email-info [headerData]="data._source" />
    </div>
  </ng-template>
</p-confirmPopup>
